import React from 'react';
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '../ui/dialog';
import { Button } from '../ui/button';

interface PlanConfirmDialogProps {
  open: boolean;
  title: string;
  description: React.ReactNode;
  confirmLabel: string;
  busyLabel?: string;
  destructive?: boolean;
  busy?: boolean;
  onConfirm: () => void;
  onClose: () => void;
}

/** Custom confirmation dialog for plan-level actions (never window.confirm). */
export const PlanConfirmDialog: React.FC<PlanConfirmDialogProps> = ({
  open,
  title,
  description,
  confirmLabel,
  busyLabel,
  destructive,
  busy,
  onConfirm,
  onClose,
}) => (
  <Dialog open={open} onOpenChange={(next) => !next && !busy && onClose()}>
    <DialogContent className="sm:max-w-[480px]" data-testid="plan-confirm-dialog">
      <DialogHeader>
        <DialogTitle>{title}</DialogTitle>
        <DialogDescription asChild>
          <div className="space-y-2 text-sm text-muted-foreground">{description}</div>
        </DialogDescription>
      </DialogHeader>
      <DialogFooter className="gap-2">
        <Button variant="outline" onClick={onClose} disabled={busy}>
          Anuluj
        </Button>
        <Button
          variant={destructive ? 'destructive' : 'default'}
          onClick={onConfirm}
          disabled={busy}
        >
          {busy ? busyLabel || 'Proszę czekać...' : confirmLabel}
        </Button>
      </DialogFooter>
    </DialogContent>
  </Dialog>
);
